import { useSelector } from 'react-redux';
import {
  selectActiveTemplate,
  selectIsFinished,
  selectIsLoaded,
  selectIsLoading,
  selectIsProcessed,
  selectLoadedTemplates,
  selectProcess,
} from 'modules/template-editor/store/templates/selectors';

/**
 * Слайс `templateEditor.templates`: шаблон и доски, загруженные трансляцией (`fetchTemplateWithBoards`), флаги
 * процессов табло, загруженные доски. Список шаблонов организации и активный шаблон редактора — не отсюда, а
 * `useOwnerBoardTemplates` / `useActiveBoardTemplate` (кэш RTK Query, IMGM-1566).
 */
function useTemplates() {
  const activeTemplate = useSelector(selectActiveTemplate);
  const isLoading = useSelector(selectIsLoading);
  const isLoaded = useSelector(selectIsLoaded);
  const isProcessed = useSelector(selectIsProcessed);
  const isFinished = useSelector(selectIsFinished);
  const currentProcess = useSelector(selectProcess);
  const loadedTemplates = useSelector(selectLoadedTemplates);

  return {
    isLoading,
    isLoaded,
    isProcessed,
    isFinished,
    activeTemplate,
    currentProcess,
    loadedTemplates,
  };
}

export default useTemplates;
